import styled from 'styled-components';

import { gridSizes } from 'utils/style';
import ZipCodeQuoteItem from 'components/form/AddressSelector/Items/ZipCodeQuote/container';

export default styled(ZipCodeQuoteItem)`
  color: var(--primary500);
  text-decoration: none;
  display: flex;
  align-items: center;

  button {
    margin: 12px;
    border-radius: 4px;
  }
  &.secondary {
    button {
      background: var(--primary100);
      color: var(--primary900);
      svg {
        fill: var(--primary900);
      }
    }
  }

  .text {
    margin-left: ${gridSizes('S')};
  }
`;
